/* eslint-disable @typescript-eslint/no-explicit-any */
const getMetaImg = async (url: string) =>
  new Promise<HTMLImageElement>((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      resolve(img);
    };
    img.onerror = (err) => {
      reject(err);
    };
    img.src = url;
  });
// const getMetaImg = (
//   url: string,
//   cb?: (err: any, img?: HTMLImageElement) => void
// ) => {
//   const img = new Image();
//   img.onload = () => {
//     if (typeof cb === 'function') {
//       cb(null, img);
//     }
//   };
//   img.onerror = (err) => {
//     if (typeof cb === 'function') {
//       cb(err);
//     }
//   };
//   img.src = url;

//   console.log(img);

//   return {
//     w: img.naturalWidth,
//     h: img.naturalHeight,
//   };
// };

export default getMetaImg;
